import { useLocation } from "react-router-dom";
import { Alert } from "../../../../domain/alert/Alert";
import useAlerts from "./useAlerts";

export const useAlertFromQueryParams = (): Alert | null | undefined => {
    const { search } = useLocation();

    const params = new URLSearchParams(search);

    const alertId = params.get("alert_id");

    const { alerts } = useAlerts();
    
    if (!alertId || !alerts || !alerts.length) return null;

    const alertMessage = alerts.find(a => a.alert.id === alertId)?.alert;

    return alertMessage;
};
